/**
 * Allow users to edit the global allowances for their Company
 *
 * @ngdoc controllers
 * @memberof mercury.modules.time.payroll.adjustment
 * @name PayrollAdjustmentEditCtrl
 * Cook Brothers Adjustments
 * We can still use Adjustment within the controller/route/factory but not once we are interrogating any data from Cyrus
 *
 */
angular.module('mercury.modules.time.payroll.adjustment')
.controller('TimePayrollAdjustmentEditCtrl', ["dialog", "$scope", "TimePayrollAdjustment", function(dialog, $scope, TimePayrollAdjustment) {
  $scope.activeTab = 'rate';

  $scope.adjustmentTypes = [
    {id: 0, label: 'Dollar amount above normal rate'},
    {id: 1, label: 'Dollar amount below normal rate'},
    {id: 2, label: 'Fixed dollar amount'},
    {id: 3, label: 'Percentage of normal rate'}
  ];

  $scope.autoAddOptions = [
    {description: 'None', id: 1},
    {description: 'All Employees', id: 2},
    {description: 'Selected Employees', id: 3},
    {description: 'Selected Roles', id: 4}
  ];

  if (!$scope.adjustment) {
    $scope.adjustment = {
      type: 0,
      rate: 0,
      autoAdd: 2,
      defaultStaff: [],
      defaultRoles: [],
      schedule: []
    };
  }

  $scope.enabledStaff = {};
  angular.forEach($scope.adjustment.defaultStaff, function(paytypeStaff) {
    $scope.enabledStaff[paytypeStaff.staffMemberId] = true;
  });

  $scope.enabledRoles = {};
  angular.forEach($scope.adjustment.defaultRoles, function(paytypeRoles) {
    $scope.enabledRoles[paytypeRoles.staffRoleId] = true;
  });

  /**
   * Save the adjustment in the edit model and close the editor dialog is successful.
   * Display any error message is one is returned from the endpoint.
   */
  $scope.saveAdjustment = function() {
    $scope.rateForm.$setSubmitted();
    if ($scope.rateForm.$invalid) {
      $scope.activeTab = 'rate';
      return;
    }

    $scope.adjustment.defaultStaff = [];
    $scope.adjustment.defaultRoles = [];

    if ($scope.adjustment.autoAdd == 3) {
      angular.forEach($scope.enabledStaff, function(enabled, staffMemberId) {
        if (enabled) {
          $scope.adjustment.defaultStaff.push({staffMemberId: staffMemberId});
        }
      });
    } else if ($scope.adjustment.autoAdd == 4) {
      angular.forEach($scope.enabledRoles, function(enabled, staffRoleId) {
        if (enabled) {
          $scope.adjustment.defaultRoles.push({staffRoleId: staffRoleId});
        }
      });
    }

    $scope.saving = TimePayrollAdjustment.save($scope.adjustment);
    $scope.saving.then(function(result) {
      $scope.$close(result);
    });
  };

  $scope.addAdjustmentSchedule = function() {
    var newSchedule = {
      datestampStart: moment().startOf('day').format(),
      datestampEnd: moment().startOf('day').add(1, 'day').format(),
      repeat: 0,
      repeatEnd: null,
      days: ''
    };
    $scope.editAdjustmentSchedule(newSchedule, null);
  };

  $scope.editAdjustmentSchedule = function(schedule, index) {
    $scope.scheduleEdit = angular.copy(schedule);

    dialog.open({
      templateUrl: 'modules/time/payroll/adjustment/editschedule.tpl.html',
      controller: 'PayrollAdjustmentEditScheduleCtrl',
      scope: $scope
    })
    .then(function(result) {
      if (index !== null) {
        $scope.adjustment.schedule.splice(index, 1, result);
      } else {
        $scope.adjustment.schedule.push(result);
      }
    });
  };

  $scope.removeAdjustmentSchedule = function(index) {
    $scope.adjustment.schedule.splice(index, 1);
  };

  $scope.summarizeSchedule = function(schedule) {
    var startTime = moment(schedule.datestampStart).format('h:mma, Do MMM');
    var endTime = moment(schedule.datestampEnd).format('h:mma, Do MMM');
    var timesDesc = 'Between ' + startTime + ' and ' + endTime;

    var endingDesc = '';
    if (schedule.repeatEnd) {
      endingDesc = ', ending ' + moment(schedule.repeatEnd).format('Do MMM YYYY');
    }

    var periodDesc = 'repeated ';
    switch (schedule.repeat) {
      case 0:
        periodDesc = '';
      break;
      case 1:
        periodDesc += 'daily';
      break;
      case 2:
        if (schedule.days === '') {
          periodDesc += 'weekly on ' + moment(schedule.datestampStart).format('dddd');
        } else if (schedule.days.split(',').length == 7) {
          periodDesc += 'weekly on all days';
        } else {
          periodDesc += 'weekly on ' + schedule.days;
        }
      break;
      case 3:
        periodDesc += 'monthly on the ' + moment(schedule.datestampStart).format('Do');
      break;
      case 4:
        periodDesc += 'yearly on ' + moment(schedule.datestampStart).format('MMM Do');
      break;
    }

    return timesDesc + ', ' + periodDesc + endingDesc;
  };
}]);
